import type { Template } from "@/types";

export const PO_06_H5_V1: Template[] = [
    {
        id: "po-06-h5v1-01",
        name: "PO 01 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 38, y: 152, width: 366, height: 523, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 412, y: 152, width: 201, height: 125, rotation: 0, imageRotation: 0 },
            { id: "3", x: 412, y: 285, width: 201, height: 125, rotation: 0, imageRotation: 0 },
            { id: "4", x: 412, y: 418, width: 201, height: 125, rotation: 0, imageRotation: 0 },
            { id: "5", x: 412, y: 551, width: 201, height: 124, rotation: 0, imageRotation: 0 },
            { id: "6", x: 696, y: 233, width: 557, height: 360, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-02",
        name: "PO 02 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 58, y: 230, width: 253, height: 366, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 319, y: 230, width: 283, height: 179, rotation: 0, imageRotation: 0 },
            { id: "3", x: 319, y: 417, width: 283, height: 179, rotation: 0, imageRotation: 0 },
            { id: "4", x: 702, y: 157, width: 530, height: 337, rotation: 0, imageRotation: 0 },
            { id: "5", x: 702, y: 502, width: 261, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 971, y: 502, width: 261, height: 168, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-03",
        name: "PO 03 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 47, y: 233, width: 557, height: 360, rotation: 0, imageRotation: 0 },
            { id: "2", x: 685, y: 152, width: 366, height: 523, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1059, y: 152, width: 201, height: 125, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1059, y: 285, width: 201, height: 125, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1059, y: 418, width: 201, height: 125, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1059, y: 551, width: 201, height: 124, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-04",
        name: "PO 04 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 92, y: 112, width: 469, height: 295, rotation: 0, imageRotation: 0 },
            { id: "2", x: 92, y: 415, width: 231, height: 146, rotation: 0, imageRotation: 0 },
            { id: "3", x: 92, y: 569, width: 231, height: 146, rotation: 0, imageRotation: 0 },
            { id: "4", x: 331, y: 415, width: 230, height: 146, rotation: 0, imageRotation: 0 },
            { id: "5", x: 331, y: 569, width: 230, height: 146, rotation: 0, imageRotation: 0 },
            { id: "6", x: 761, y: 112, width: 424, height: 603, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-05",
        name: "PO 05 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 61, y: 246, width: 527, height: 336, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 718, y: 64, width: 509, height: 303, rotation: 0, imageRotation: 0 },
            { id: "3", x: 718, y: 375, width: 252, height: 161, rotation: 0, imageRotation: 0 },
            { id: "4", x: 978, y: 375, width: 251, height: 161, rotation: 0, imageRotation: 0 },
            { id: "5", x: 718, y: 544, width: 165, height: 219, rotation: 0, imageRotation: 0 },
            { id: "6", x: 891, y: 544, width: 337, height: 219, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-06",
        name: "PO 06 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_06.png",
        size: [1298, 827],
        style: {},
        slots: [        
            { id: "1", x: 0, y: 246, width: 259, height: 164, rotation: 0, imageRotation: 0 },
            { id: "2", x: 0, y: 418, width: 259, height: 163, rotation: 0, imageRotation: 0 },
            { id: "3", x: 267, y: 246, width: 258, height: 164, rotation: 0, imageRotation: 0 },
            { id: "4", x: 267, y: 418, width: 258, height: 163, rotation: 0, imageRotation: 0 },   
            { id: "5", x: 533, y: 246, width: 234, height: 334, rotation: 0, imageRotation: 0 },
            { id: "6", x: 775, y: 246, width: 523, height: 334, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-07",
        name: "PO 07 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 175, width: 329, height: 477, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 337, y: 175, width: 193, height: 114, rotation: 0, imageRotation: 0 },
            { id: "3", x: 337, y: 297, width: 193, height: 113, rotation: 0, imageRotation: 0 },
            { id: "4", x: 337, y: 418, width: 193, height: 113, rotation: 0, imageRotation: 0 },
            { id: "5", x: 337, y: 539, width: 193, height: 113, rotation: 0, imageRotation: 0 },
            { id: "6", x: 538, y: 175, width: 761, height: 477, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-08",
        name: "PO 08 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 66, y: 512, width: 271, height: 179, rotation: 0, imageRotation: 0 },
            { id: "2", x: 66, y: 136, width: 271, height: 368, rotation: 0, imageRotation: 0 },
            { id: "3", x: 345, y: 136, width: 441, height: 274, rotation: 0, imageRotation: 0 },
            { id: "4", x: 345, y: 418, width: 441, height: 273, rotation: 0, imageRotation: 0 },
            { id: "5", x: 794, y: 136, width: 440, height: 274, rotation: 0, imageRotation: 0 },
            { id: "6", x: 794, y: 418, width: 440, height: 273, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-09",
        name: "PO 09 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 66, y: 139, width: 227, height: 298, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 301, y: 139, width: 462, height: 298, rotation: 0, imageRotation: 0 },
            { id: "3", x: 771, y: 139, width: 461, height: 298, rotation: 0, imageRotation: 0 },
            { id: "4", x: 66, y: 445, width: 384, height: 245, rotation: 0, imageRotation: 0 },
            { id: "5", x: 458, y: 445, width: 384, height: 245, rotation: 0, imageRotation: 0 },
            { id: "6", x: 850, y: 445, width: 383, height: 245, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-06-h5v1-10",
        name: "PO 10 - H5V1",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-06-h5_v1_10.png",
        size: [1298, 827],
        style: {},
        slots: [           
            { id: "2", x: 83, y: 116, width: 300, height: 193, rotation: 0, imageRotation: 0 },
            { id: "3", x: 83, y: 317, width: 300, height: 193, rotation: 0, imageRotation: 0 },
            { id: "4", x: 83, y: 518, width: 300, height: 193, rotation: 0, imageRotation: 0 },
            { id: "1", x: 391, y: 116, width: 420, height: 595, rotation: 0, imageRotation: 0 },
            { id: "5", x: 819, y: 116, width: 417, height: 294, rotation: 0, imageRotation: 0 },
            { id: "6", x: 819, y: 418, width: 417, height: 293, rotation: 0, imageRotation: 0 }
        ],
    }
];